import { Company, UserType } from '@kanda-libs/ks-frontend-services';

export interface User {
  firstName: string;
  lastName?: string;
  name: string;
  email: string;
  mobile?: string;
  company: string;
  cid: string;
}

const getCompanyName = (company: Company): string => {
  const contactName = company?.contact_info?.trading_name;
  if (company.company_type === 'limited_company')
    return (
      contactName ||
      company?.limited_company_info?.company_name ||
      'No company name'
    );
  return (
    contactName || company?.sole_trader_info?.trading_name || 'No company name'
  );
};

const formatUsersArray = (
  companyName: string,
  cid: string,
  usersArray?: UserType[],
): User[] | undefined => {
  if (!usersArray) return undefined;
  return usersArray.map((user: UserType) => ({
    firstName: user.first_name,
    lastName: user?.last_name,
    name: [user.first_name, user?.last_name].filter(Boolean).join(' '),
    email: user.email,
    mobile: user?.mobile,
    company: companyName,
    cid,
  }));
};

export const extractUserArray = (
  isLoading: boolean,
  companies?: Company[],
): User[] => {
  if (isLoading || !companies) return [];
  return companies.reduce((all: User[], company: Company) => {
    const companyName = getCompanyName(company);
    const cid = company?.cid || '';
    const usersArray = formatUsersArray(companyName, cid, company?.users);
    const name = company?.contact_info?.contact_name?.split(' ');
    const email = company?.contact_info?.contact_email;
    const phone = company?.contact_info?.contact_phone;
    if (!email) {
      if (!usersArray) return all;
      return [...all, ...usersArray];
    }
    const contactUser: User = {
      firstName: name?.[0] || '--',
      lastName: name?.slice(1)?.join(' '),
      name: company?.contact_info?.contact_name || '--',
      email,
      mobile: phone,
      company: companyName,
      cid,
    };
    return [...all, contactUser, ...(usersArray || [])];
  }, []);
};
